import SEO from '@/components/base/SEO';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import CategoryNav from './components/CategoryNav';
import NewReleases from './components/NewReleases';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SEO
        title="6080影院 - 高清电影免费看 | 免费电视剧全集"
        description="6080影院汇集高清电影免费看和免费电视剧全集，高清在线影院级画质，免费影视大全无需付费，高清视频播放流畅不卡。涵盖动作片、喜剧片、爱情片、科幻片、恐怖片、动漫等海量资源。"
        keywords="高清电影免费看,免费电视剧全集,高清在线影院,免费影视大全,高清视频播放,6080影院"
        canonicalUrl="https://www.6080cinema.com/"
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '6080影院首页',
            description: '6080影院汇集高清电影免费看和免费电视剧全集，高清在线影院级画质，免费影视大全无需付费。',
            url: 'https://www.6080cinema.com/',
            isPartOf: {
              '@type': 'WebSite',
              name: '6080影院',
              url: 'https://www.6080cinema.com',
            },
          }),
        }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <FeaturedSection />
          <CategoryNav />
          <NewReleases />
          <FAQSection />
        </main>
        <Footer />
      </div>
    </>
  );
}